import Vue from 'vue'
import { initVue } from './utils/shared-initialization'

# Mount Vue components
initVue()
